import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';

const view = '[data-view="chrome_extensions"]';
const init = () => {
    createAppWrap({
        el: view,
        mixins: [
            commonMixin
        ],
        created() {
            this.$_loading();
            // 拡張機能からinstalledのmessageが通知されたらメインページにinstalled通知を送る
            window.addEventListener('message', (e) => {
                if (typeof e.data.action !== 'undefined' && e.data.action === 'installed') {
                    window.opener.postMessage({action: 'installed'}, '*');
                }
            });
            // ページ読み込み後閉じる
            window.addEventListener('load', () => {
                window.opener.postMessage({action: 'not_installed'}, '*');
                window.open('about:blank', '_self').close();
            });
        }
    });
};

if (document.querySelector(view)) {
    init();
}
